// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9f193fb0","455":"9adddf60","977":"86c38940"}[chunkId] + ".chunk.js";
};